<template>
  <div id="google-pay-button" class="google-pay-button"></div>
</template>

<script>
import HTTP from 'axios';
import { mapState, mapMutations } from 'vuex';

// import logrocket from '@/services/logrocket';
import HTTPService from '@/services/Http';

import { API_URL } from '@/.env';

const GATEWAY = {
  test: {
    gateway: 'kassacom',
    gatewayMerchantId: 'kassacom-test',
  },
  prod: {
    gateway: 'kassacom',
    gatewayMerchantId: 'capusta',
  },
};

const ENVIRONMENT = {
  test: { environment: 'TEST' },
  prod: { environment: 'PRODUCTION' },
};

export default {
  name: 'GooglePay',
  props: {
    label: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    requestData: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.onGooglePayLoaded();
  },
  data() {
    return {
      paymentId: null,
      paymentsClient: null,
      baseRequest: {
        apiVersion: 2,
        apiVersionMinor: 0,
      },
      baseCardPaymentMethod: {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['MASTERCARD', 'VISA'],
        },
      },
      tokenizationSpecification: {
        type: 'PAYMENT_GATEWAY',
        parameters: GATEWAY.prod,
      },
      internalDisabled: false,
    };
  },
  computed: {
    ...mapState(['PROJECT', 'TRANSACTION_KEY']),
  },
  watch: {
    disabled: {
      immediate: true,
      handler(val) {
        this.internalDisabled = val;
      },
    },
  },
  methods: {
    getGoogleTransactionInfo() {
      return {
        countryCode: 'RU',
        currencyCode: this.PROJECT.currency.code,
        totalPriceStatus: 'FINAL',
        totalPrice: this.amount.replace(/\s/g, ''),
      };
    },
    cardPaymentMethod() {
      return Object.assign(
        {},
        this.baseCardPaymentMethod,
        {
          tokenizationSpecification: this.tokenizationSpecification,
        }
      );
    },
    getGoogleIsReadyToPayRequest() {
      return Object.assign(
        {},
        this.baseRequest,
        {
          allowedPaymentMethods: [this.baseCardPaymentMethod],
        }
      );
    },
    getGooglePaymentDataRequest() {
      const paymentDataRequest = Object.assign({}, this.baseRequest);
      paymentDataRequest.allowedPaymentMethods = [this.cardPaymentMethod()];
      paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo();
      paymentDataRequest.merchantInfo = {
        merchantId: 'BCR2DN6TVOT3JQQQ',
        merchantName: 'Example Merchant',
      };
      return paymentDataRequest;
    },
    getGooglePaymentsClient() {
      if (this.paymentsClient === null) {
        // eslint-disable-next-line no-undef
        this.paymentsClient = new google.payments.api.PaymentsClient(ENVIRONMENT.prod);
      }
      return this.paymentsClient;
    },
    async onGooglePayLoaded() {
      const paymentsClient = this.getGooglePaymentsClient();

      try {
        const { result } = await paymentsClient.isReadyToPay(this.getGoogleIsReadyToPayRequest());
        if (result) {
          this.addGooglePayButton();
        }
      } catch (error) {
        // logrocket.logger(error);
      }
    },
    addGooglePayButton() {
      const paymentsClient = this.getGooglePaymentsClient();
      const button = paymentsClient.createButton({
        buttonColor: 'default',
        buttonType: 'short',
        onClick: this.onGooglePaymentButtonClicked,
      });
      document.getElementById('google-pay-button').appendChild(button);
    },
    async onGooglePaymentButtonClicked() {
      if (this.internalDisabled) {
        this.$emit('click-on-disabled');
        return;
      }

      this.internalDisabled = true;
      this.$emit('loading', true);

      await this.createPayment();

      const paymentDataRequest = this.getGooglePaymentDataRequest();
      paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo();

      console.log('paymentDataRequest', paymentDataRequest);

      const paymentsClient = this.getGooglePaymentsClient();

      try {
        const paymentData = await paymentsClient.loadPaymentData(paymentDataRequest);
        await this.processPayment(paymentData);
      } catch (error) {
        // logrocket.logger(error);
      }

      this.internalDisabled = false;
      this.$emit('loading', false);
    },
    createPayment() {
      console.log('handlePayment::createPayment', this.requestData);
      HTTPService.createPayment(this.requestData)
        .then(response => {
          const { data } = response;
          console.log('CREATE_PAYMENT::RESPONSE', data);

          this.SET_TRANSACTION(data);
          this.SET_TRANSACTION_KEY(this.label);

          this.paymentId = data.id;
          console.log('paymentId', this.paymentId);
        })
        .catch(error => {
          console.log(error);
          // logrocket.logger(error);
        });
    },
    performTransaction(paymentData) {
      console.log('performTransaction::paymentData', paymentData);
      return HTTP.post(
        `${API_URL}token/sale`,
        {
          paymentId: this.paymentId,
          tokenData: paymentData,
          tokenType: 'googlepay',
        },
        {
          headers: { 'Access-Control-Allow-Origin': '*' },
        }
      );
    },
    async processPayment(paymentData) {
      try {
        const { data } = await this.performTransaction(paymentData);

        console.log('processPayment', data);

        const { externalDigitalContentCode, enrolled } = data;
        console.log('last4Digits|enrolled', externalDigitalContentCode, enrolled);

        sessionStorage.setItem('passwordCard', externalDigitalContentCode);

        if (enrolled) {
          this.$router.push({
            name: 'ThreeDSecure',
            params: {
              data,
            },
          });
          return;
        }

        this.$router.push({ name: 'pending.payment' });
      } catch (error) {
        // logrocket.logger(error);
      }
    },
    ...mapMutations(['SET_TRANSACTION', 'SET_TRANSACTION_KEY']),
  },
};
</script>

<style lang=sass>
  .gpay-button.black.short
    width: 100% !important
    height: 50px
    margin: 0
    border-radius: 50px
    background-size: 45px
</style>

<style lang="sass" scoped>
  .google-pay-button
    width: 100%
</style>
